<!-- section template -->
<template>
  <div :class="$style.listReservationJtails">
    <ReservationSectionTitle :store-item="storeItem" :date="tempSubmitData.date" class="d-lg-none mb-3" />
    <ul :class="[$style.reservationList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
      <li v-for="(reservationItem, index) in reservationList" :key="`reservationList-${index}`" class="reservationList__item" @click="goToReservationItem({ reservationAlias: reservationItem.alias })">
        <div class="row">
          <div :class="$globalIsDingBeauty ? 'col-md-5' : 'col-md-4'">
            <div
              class="reservationList__image"
              :class="{ isStyleDingBeauty: $globalIsDingBeauty }"
              :style="{
                backgroundImage: `url('${getDefaultImage(reservationItem.images) || require(`@assets/images/${$globalProjectName}/default/plan-default-Image@2x.png`)}`,
              }"
            >
              <div v-if="!!reservationItem.store && !!reservationItem.store.title" class="reservationList__store">
                {{ reservationItem.store.title }}
              </div>
            </div>
          </div>
          <div :class="$globalIsDingBeauty ? 'col-md-7' : 'col-md-8'">
            <div class="row gx-2">
              <div :class="reservationItem.levelDiscount > 0 ? 'col-md-7' : 'col-md-8'">
                <div class="reservationList__title">
                  {{ reservationItem.title }}
                </div>
                <div class="reservationList__meta"
                  ><span v-if="$globalCategoryVisible">{{ reservationItem.categoryTitle }} | {{ reservationItem.sizeTitle }}•</span> <i class="fontello fontello-time"></i>
                  {{ formatServiceTime(reservationItem.serviceTime) }}
                </div>
              </div>
              <div :class="reservationItem.levelDiscount > 0 ? 'col-md-5' : 'col-md-4'" class="order-1 order-md-0">
                <div class="reservationList__action">
                  <div>
                    <div class="reservationList__price">
                      {{ reservationItem.levelDiscount > 0 ? '會員價 NT$' + formatCurrency(memberLevelPriceDiscount(reservationItem.price, reservationItem)) : formatPrice(reservationItem.price) }}
                      <span v-if="!!reservationItem.priceIsFlexible" class="fs-sm">起</span>
                    </div>
                    <div v-if="reservationItem.levelDiscount > 0" class="reservationList__basePrice text-decoration-line-through"> 售價 NT${{ formatCurrency(reservationItem.price) }} </div>
                    <div v-if="reservationItem.price < reservationItem.basePrice && !reservationItem.levelDiscount > 0" class="reservationList__basePrice text-decoration-line-through">
                      原價 NT${{ formatCurrency(reservationItem.basePrice) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="reservationList__description" v-html="reservationItem.description"></div>
              </div>
              <div class="col-12 info-wrapper">
                <BaseButton class="isStyleDark isSmall isOutline3" @click.stop="goToReservationItem({ reservationAlias: reservationItem.alias })">查看更多</BaseButton>
                <BaseButton class="isStyleDark isSmall isOutline3" @click.stop="openDialogScheduleItem(reservationItem.alias)">預約時段</BaseButton>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <BasePre>reservationList: {{ reservationList }}</BasePre>
    <BasePre>reservationPagination: {{ reservationPagination }}</BasePre>
  </div>
</template>

<script>
import formatDate from '@utils/format-date'
import formatCurrency from '@utils/format-currency'
import { authComputed, merchantComputed } from '@store/helpers'
import { getStoreOption } from '@utils/ipetbooking-options'
import formatServiceTime from '@utils/format-service-time'
import formatPrice from '@utils/format-price'
import { reservationTimeList } from '@utils/ipetbooking-reservation'
import { memberLevelPriceDiscount } from '@utils/ipetbooking-level'

export default {
  components: {
    ReservationSectionTitle: () => import('@components/Reservation/ReservationSectionTitle'),
  },
  props: {
    reservationList: {
      type: Array,
      default: () => {
        return [
          {
            title: 'A. 小美容',
            alias: 'store-small-dog-a',
            basePrice: 1000,
            price: 700,
            images: [
              {
                path: 'https://assets.codepen.io/1759070/service-1%402x.png',
                default: 1,
              },
              {
                path: 'https://assets.codepen.io/1759070/service-2%402x.png',
                default: 0,
              },
              {
                path: 'https://assets.codepen.io/1759070/service-3%402x.png',
                default: 0,
              },
            ],
            store: {
              title: '台北店',
            },
            sizeTitle: '小型 (3-5kg)',
            categoryTitle: '狗狗',
            serviceTime: 120,
            description: '迷你犬基礎洗護（含：剪指甲、清耳朵、小修臉部雜毛、小修足緣、剃腳底毛、剃肚子毛、剃肛門毛擠肛門腺+牛奶SPA浴程）',
            times: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30'],
          },
        ]
      },
    },
    reservationPagination: {
      type: Object,
      default: () => {
        return {
          current_page: 1,
          first_page_url: 'http://admin.ds.test/api/merchant/prepaids?page=1',
          from: 1,
          last_page: 1,
          last_page_url: 'http://admin.ds.test/api/merchant/prepaids?page=1',
          next_page_url: null,
          path: 'http://admin.ds.test/api/merchant/prepaids',
          per_page: 6,
          prev_page_url: null,
          to: 3,
          total: 50,
        }
      },
    },
    tempSubmitData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    serviceList: {
      type: Array,
      default: () => {
        return [
          {
            title: 'A. 小美容',
            description: '洗澡小美容服務項目包含：剪指甲／剃腳底毛／剃肛門毛／剃肚子毛／清耳朵／擠肛門腺／小修足緣／小修臉部雜毛',
            items: [
              {
                title: '迷你 (3kg以下)',
                alias: 'alias1',
                price: 900,
                serviceTime: 90,
              },
            ],
          },
        ]
      },
    },
    serviceType: {
      type: String,
      default: 'cosmetic',
      validator(value) {
        return ['cosmetic', 'daycare'].includes(value)
      },
    },
  },
  data() {
    return {
      session: 'all',
      tempSelectItem: {
        reservationAlias: '',
        time: '',
      },
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    storeItem() {
      return getStoreOption({
        value: this.tempSubmitData.storeAlias,
        type: 'item',
      })
    },
    displayTimeMax() {
      return this.$globalIsDingBeauty || this.$globalWindowWidth <= 1300 ? 3 : 4
    },
  },
  methods: {
    getStoreOption,
    formatPrice,
    formatDate,
    formatCurrency,
    formatServiceTime,
    memberLevelPriceDiscount,
    goToReservationItem({ reservationAlias, isSectionDate = false }) {
      this.tempSelectItem.reservationAlias = reservationAlias

      this.$router.push({
        name: 'reservation-item',
        params: {
          reservationAlias,
        },
        query: {
          date: this.tempSubmitData.date,
          section: isSectionDate ? 'date' : undefined,
          petId: this.tempSubmitData.petId && this.tempSubmitData.isUserMemberPet ? this.tempSubmitData.petId : undefined,
          scheduleItemId: this.tempSubmitData.scheduleItemId,
        },
      })
    },
    getDefaultImage(images) {
      const defaultImageItems = images.filter((image) => image.default) || []

      return defaultImageItems[0]?.path || ''
    },
    /**
     * @description 將timesInfo組成時間列表
     */
    getTimesInfoArr({ timesInfo }) {
      let timeArr = []
      for (let key in timesInfo) {
        if (timesInfo[key]['canTimeOrder']) {
          timeArr.push(key)
        }
      }
      return timeArr
    },
    timeList(reservationItem) {
      return reservationTimeList({
        date: this.tempSubmitData.date,
        storeAlias: reservationItem.store.alias,
        times: this.getTimesInfoArr(reservationItem),
        startTime: this.tempSubmitData.time,
        storeType: reservationItem.store.storeType,
      })
    },
    displayTimeList(reservationItem) {
      const displayTimeMax = this.displayTimeMax
      const timeList = this.timeList(reservationItem)
      return timeList.slice(0, displayTimeMax)
    },
    onClickTime({ reservationAlias, time, reservationStoreAlias }) {
      const loggedInFn = () => {
        const isNotCanSelectStore = () => {
          if (this.isHasReservationInCart) {
            return reservationStoreAlias !== this.currentUnpaidContiner[0].orders.items[0].product.alias
          } else {
            return false
          }
        }
        if (this.isBlock) {
          this.$globalDialog('DialogBlock', {})
          return
        }
        if (this.isHasReservationInCart && !!this.currentUnpaidContiner[0]?.['parent_id']) {
          this.$alert(`加購訂單尚未結帳完成，無法加入新預約`, {
            title: `提示`,
            showClose: false,
            dangerouslyUseHTMLString: true,
          }).finally(() => {})
          return false
        }
        if (this.isHasReservationInCart && isNotCanSelectStore()) {
          this.$alert(`無法預約不同分店，請重新選擇`, {
            title: `提示`,
            showClose: false,
            dangerouslyUseHTMLString: true,
          }).finally(() => {})
          return false
        }
        this.$nextTick(() => {
          const loadingMaskCheckOutCart = this.$loading({
            lock: true,
            text: '前往下一步',
            spinner: `fal fa-circle-notch fa-spin`,
            background: 'rgba(81, 176, 202, 0.3)',
            customClass: 'isStyleCheckout',
          })

          this.tryToStoreCart({
            reservationAlias,
            time,
          })
            .then(() => {
              const goToReservationCheckout = () => {
                // this.$router.push({
                //   name: 'reservation-checkout',
                //   params: {
                //     reservationAlias
                //   },
                // });
                this.$router.push({
                  name: 'add-reservation',
                  params: {
                    reservationAlias,
                  },
                })
              }

              goToReservationCheckout()
            })
            .catch((e) => {
              if (e.status === 'STATUS_CODE_UNDEFINED') {
                this.$globalDialog('DialogBlock', {})
              }
            })
            .finally(() => {
              loadingMaskCheckOutCart.close()
            })
        })
      }

      if (this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          },
        })
      }
    },
    async tryToStoreCart({ reservationAlias, time }) {
      if (this.$isLoading('storeCart')) {
        return false
      }

      this.tempSelectItem = {
        reservationAlias,
        time,
        scheduleItemIds: this.tempSubmitData.scheduleItemId ? [this.tempSubmitData.scheduleItemId] : undefined,
      }

      await this.$store
        .dispatch('cart/storeCart', {
          prepaidOrderUuid: this.tempSubmitData.prepaidId || undefined,
          inventoryAlias: `${this.tempSubmitData.date} ${time}`,
          params: [
            {
              alias: reservationAlias,
              qty: 1,
            },
          ],
          scheduleItemIds: [this.tempSubmitData.scheduleItemId],
          petId: this.tempSubmitData.petId && this.tempSubmitData.isUserMemberPet ? this.tempSubmitData.petId : undefined,
        })
        .then(() => {
          return true
        })
    },
    openDialogScheduleItem(reservationAlias) {
      if (this.isLoggedIn) {
        const urlParams = new URLSearchParams(window.location.search)
        const scheduleItemId = urlParams.get('scheduleItemId')

        this.$globalDialog('DialogScheduleService', {
          scheduleItem: { id: scheduleItemId },
          defaultValue: { reservationAlias },
          type: 'reservation-item',
          callbackChangeSchedule() {},
        })
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin() {},
        })
      }
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.listReservationJtails {
  :global {
    .info-wrapper {
      display: flex;
      gap: 18px;

      button {
        flex: 1;
      }
    }

    .listReservationJtails {
      &__timeBox {
        @include max-xl {
          .baseButton {
            padding: 0.8rem 1rem;
          }
        }

        @include max-md {
          .baseButton {
            padding: 0.6rem 1rem;
          }
        }
      }

      &__pagination {
        margin-top: 1rem;
      }
    }
  }
}

.reservationList {
  @include list-unstyled;

  :global {
    .reservationList {
      &__action {
        @include max-md {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 1.5rem;
        }
      }

      &__image {
        position: relative;
        padding-top: 73%;
        overflow: hidden;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
        transition: transform 0.3s;
        transform: scale(1);

        @include max-md {
          margin-bottom: 1rem;
        }

        &::before {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 1;
          content: '';
          background: rgba(#000, 0.4);
          opacity: 0;
          transition: opacity 0.3s;
        }

        &::after {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 1;
          padding: 0.875rem 1.75rem;
          color: #fff;
          white-space: nowrap;
          content: '查看詳細內容';
          border: 1px solid #fff;
          border-radius: 10px;
          opacity: 0;
          transition: opacity 0.3s;
          transform: translate(-50%, -50%);
        }

        &.isStyleDingBeauty {
          &::after {
            border-radius: 0;
          }
        }
      }

      &__title {
        margin-bottom: 0.25rem;
        font-family: $font-serif;
        font-size: 1.125rem;
        font-weight: 600;

        @include max-md {
          margin-bottom: 1rem;
        }
      }

      &__item {
        padding: 1.875rem 0;
        cursor: pointer;

        &:first-child {
          padding-top: 0;
        }

        &:last-child {
          padding-bottom: 0;
        }

        &:not(:last-child) {
          border-bottom: 1px solid $color-line;
        }

        &:hover {
          .reservationList {
            &__title {
              color: $color-primary;
            }

            &__image {
              &::before {
                opacity: 1;
              }

              &::after {
                opacity: 1;
              }
            }
          }
        }

        .isText {
          color: $color-primary;
          border-bottom: $color-primary 1px solid;
        }
      }

      &__price {
        margin-bottom: 0.25rem;
        font-family: $font-number;
        font-size: 1.25rem;
        font-weight: 600;
        color: $color-primary;
        text-align: right;

        @include max-xl {
          font-size: 1.125rem;
        }

        @include max-md {
          text-align: left;
        }
      }

      &__basePrice {
        font-family: $font-number;
        font-size: 0.875rem;
        color: #b9b9b9;
        text-align: right;
        letter-spacing: 0.1em;

        @include max-md {
          text-align: left;
        }
      }

      &__meta {
        margin-bottom: 0.75rem;
        font-size: 0.75rem;
        color: $color-gray-2;
      }

      &__description {
        @include line-clamp(3, 4.5em);

        margin-bottom: 1rem;
        font-size: 0.875rem;
        line-height: 1.5;
        color: $color-gray-2;
        white-space: pre-wrap;
      }

      &__store {
        position: absolute;
        top: 1.5rem;
        left: 0;
        padding: 0.25rem 0.5rem 0.25em 1.25rem;
        font-size: 0.75rem;
        color: #fff;
        background: $color-primary;
      }
    }
  }

  &.isStyleDingBeauty {
    :global {
      .reservationList {
        &__store {
          padding: 0.25rem 0.5rem 0.25em 1rem;
          background: $color-gray-3;
          font-weight: 400;
        }

        &__price {
          color: $color-secondary;
          font-weight: 400;
          font-size: 1.125rem;
        }

        &__image {
          padding-top: 57.9%;
        }

        &__basePrice {
          color: #646a6f;
        }
      }
    }
  }
}

.timeList {
  @include list-unstyled;

  display: flex;
  width: 100%;
  padding-bottom: 1px;
  overflow-x: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }

  :global {
    .timeList {
      &__item {
        &:not(:last-child) {
          margin-right: 1rem;
        }
      }
    }
  }
}
</style>
